<template>
    <div id="player" class="player-mod">
        <div class="cloud-fillter" :style="{ position: headTop }">
            <div class="cloud-fillter-inner flex">
                <div>
                    <reo-select v-model="device" :options="[
                        {

                            label: this.$t( 'all' ),
                            value: ''
                            
                        }, ...deviceList
                    ]"></reo-select>
                </div>
                <div>
                    <datepicker v-model="date" :available="available" class="cloud-datepicker"></datepicker>
                </div>
            </div>
        </div>
        <section>
            <nav>
                <a v-on:click="goBack">
                    <span class="go-back"><i class="go-back-icon ui-icon icon-icon_back"></i>{{ $t('video.goBack') }}</span>
                </a>
            </nav>
            <main>
                <video-player :videoInfo="videoInfo" v-if="videoInfoState"></video-player>
                <video-other :currentDevice="currentDevice" :videoInfo="videoInfo" :deviceList="deviceObj" v-if="videoInfoState"></video-other>
            </main>
        </section>
    </div>
</template>

<script>

import videoPlayer from '@/view/videos/videoPlayer';
import videoOther from '@/view/videos/otherVideos';
import ReoSelect from '@/basic/Select';
import Datepicker from '@/basic/Datepicker';
import { getDeviceInfoHasVideo, getVideoInfoById, getTimeMap } from '@/api/cloud';
import { mapActions } from 'vuex';

export default {

    components: {
        videoPlayer,
        videoOther,
        Datepicker,
        ReoSelect
    },

    created () {

        this.getTimeMap();
        this.getVideoInfo( this.videoId );

    },

    mounted () {

        window.addEventListener( 'scroll', this.scroll );

    },

    data () {

        return {

            videoId: this.$route.query.videoId,
            videoInfoState: false,
            device: this.$route.query.device || '',
            deviceList: [],
            available: [],
            date: this.$route.query.date || 'All-All-All',
            videoInfo: '',
            deviceObj: {},
            currentDevice: '',
            headTop: false

        };

    },

    methods: {

        async getDeviceList () {

            await getDeviceInfoHasVideo().then( devices => {

                let deviceList = [];
                devices.forEach(( device ) => {

                    if ( device.uid ) {

                        this.deviceObj[device.uid] = device.title || device.uid;

                        if ( device.uid === this.videoInfo.uid ) {
                            
                            this.videoInfo.deviceName = device.title || device.uid;

                            this.currentDevice = device.title || device.uid;

                        }

                        deviceList.push({

                            label: device.title || device.uid,
                            status: device.status === 'associated' ? '' : 'unbound',
                            value: device.uid

                        });

                    }

                });
                this.deviceList = deviceList;

            }).catch( err => {

                console.error( err );

            });

        },

        async getVideoInfo ( videoId ) {

            await getVideoInfoById( videoId ).then( res => {

                this.videoInfo = res;

                this.videoInfoState = true;

                this.getDeviceList();

            }).catch( err => {

                if ( err.response.data.error.code === 32774 ) {

                    this.topInfoToggle({

                        type: 'error',
                        msgIndex: 'errors.video_no_found'

                    });

                } else {

                    this.topInfoToggle({

                        type: 'error',
                        msgIndex: 'errors.error_unknow'

                    });

                }

            });

        },

        getTimeMap ( uid ) {

            getTimeMap( this.device ).then( timeMap => {

                this.available = timeMap;

            }).catch( err => {

                console.error( err );

            });

        },

        goBack () {

            this.$router.back( -1 );

        },

        ...mapActions( [

            'topInfoToggle'

        ] ),

        scroll () {

            let scroll = document.body.scrollTop || document.documentElement.scrollTop;

            if ( scroll >= 64 ) {

                this.headTop = 'fixed';

            } else {

                this.headTop = 'static';

            }

        }
    
    },

    watch: {

        $route () {
            
            this.videoId = this.$route.query.videoId;

            this.getVideoInfo( this.videoId );

        },

        date ( val ) {

            this.$router.push({path: '/user/cloud-library/', query: { date: val }});

        },

        device ( val ) {

            this.$router.push({path: '/user/cloud-library/', query: { device: val }});

        }

    }

};

</script>

<style lang="less">

    body{ background-color: #fff; }

    .cloud-fillter{
        background: #F3F4F9;
        height: .8rem;
    }

    .cloud-fillter-inner{
        max-width: 600px;
        margin: auto;
        height: .8rem;
        align-items: center;
        box-sizing: border-box;
        position: relative;
    }

    .cloud-fillter-inner>div{
        width:50%;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        padding: 0.05rem 0;
    }
    .cloud-datepicker{
        display: inline-block;
    }

    .player-mod section{
        width: 1200px;
        margin: 0 auto;
    }
    .player-mod nav a{
        display: inline-block;
        line-height: .5rem;
        color: #666;
        font-weight: 500;
        font-size: .16rem;
        cursor: pointer;
    }

    .player-mod .go-back-icon{
        font-size: .22rem;
        color: #666;
        position: relative;
        top: 0.01rem;
        margin-right: .1rem;
    }

    .go-back:hover{
        color: @theme;
    }

    .go-back:hover .go-back-icon{
        color: @theme;
    }

    @media screen and ( max-width: 1199px ) {

        .player-mod .go-back-icon{
            font-size: .28rem;
        }

        .player-mod section{
            width: 100%;
            margin: 0 auto;
        }

        .player-mod nav{
            padding: 0 15px;
        }

        .section nav a{
            height: .88rem;
            color: #666;
            font-size: .26rem;
            font-weight: 500;
        }

        .cloud-fillter-inner{
            max-width: 100%;
        }
        .cloud-fillter-inner:after{
            content: '';
            display: block;
            width: 1px;
            height: 0.5rem;
            border-left: 1px solid #ccc;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        .player-mod nav a{
            font-size: .26rem;
            color: #666;
            line-height: .88rem;
        }

    }

</style>



// WEBPACK FOOTER //
// src/view/videos/index.vue